export default {
    PROJECT_DETAILS: "project"
};
